var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadBarPiece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "69.25px",
    height: "21.881px",
    viewBox: "0 0 69.25 21.881",
    enableBackground: "new 0 0 69.25 21.881",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.783,
    y: 0.884,
    opacity: 0.8,
    fill: "#F5F6F6",
    width: 67.804,
    height: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadBarPiece);
export default __webpack_public_path__ + "static/media/load_bar_piece.c2850f82609ab288d14018441eb6ebc1.svg";
export { ForwardRef as ReactComponent };